import { FormCustomerCheckoutInfo } from '../../components/Forms/Checkout';
import ListCartProduct from '../../components/Lists/ListCartProduct';
import * as React from 'react';
import { useCartStore } from '../../stores/cart';
import Scheduling from './DeliveryItems/Scheduling';

interface WithdrawProps {
  active: boolean;
  setExtensionCustomCouponCode: (code: string | undefined) => void;
  setExtensionCustomDeliveryFee: (fee: number | string | undefined) => void;
}

const Withdraw: React.FC<WithdrawProps> = ({
  active,
  setExtensionCustomCouponCode,
  setExtensionCustomDeliveryFee,
}) => {
  const { isExtension } = useCartStore((state) => ({
    isExtension: state.isExtension,
  }));
  if (!active) return null;

  return (
    <div className={isExtension ? '' : 'mt-[110px]'}>
      {isExtension && (
        <>
          <Scheduling />

          <FormCustomerCheckoutInfo
            setExtensionCustomCouponCode={setExtensionCustomCouponCode}
            setExtensionCustomDeliveryFee={setExtensionCustomDeliveryFee}
          />
        </>
      )}

      <ListCartProduct />
    </div>
  );
};

export default Withdraw;
